var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCyclingMount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.9,77.3c6.1,0,11.9,2.4,16.3,6.7c4.3,4.3,6.7,10.1,6.7,16.3c0,6.1-2.4,11.9-6.7,16.3c-4.3,4.3-10.1,6.7-16.3,6.7 c-6.1,0-11.9-2.4-16.3-6.7s-6.7-10.1-6.7-16.3c0-6.1,2.4-11.9,6.7-16.3S96.7,77.3,102.9,77.3 M102.9,74.6 c-14.2,0-25.7,11.5-25.7,25.7S88.6,126,102.9,126s25.7-11.5,25.7-25.7S117.1,74.6,102.9,74.6L102.9,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9,28.4c6.1,0,11.9,2.4,16.3,6.7s6.7,10.1,6.7,16.3s-2.4,11.9-6.7,16.3S37,74.4,30.9,74.4S19,72,14.6,67.7 S7.9,57.6,7.9,51.4s2.4-11.9,6.7-16.3C18.9,30.8,24.7,28.4,30.9,28.4 M30.9,25.7c-14.2,0-25.7,11.5-25.7,25.7s11.5,25.7,25.7,25.7 c14.2,0,25.7-11.5,25.7-25.7S45.1,25.7,30.9,25.7L30.9,25.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.7,53.2v-21c0-2.3-0.8-4.7-2.6-6.5c-1.8-1.8-4.1-2.6-6.4-2.6H69.4l18,18h17v14.1c0,1.4,0.6,2.7,1.5,3.7l16.3,16.4 c2,2,5.3,2,7.3,0c2-2,2-5.3,0-7.3L114.7,53.2z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 124.7,
    cy: 21.9,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7,25.6c-2.3,2.3-3.4,5.2-3.4,8.2v61.3c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1V80.5L92,60.1c2-2,2-5.3,0-7.3 L64.7,25.6z M71.6,47.1l9.4,9.4L71.6,66V47.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "53,106.7 90.3,144 94.1,144 54.1,104 31.6,104 0,72.4 0,76.3 30.5,106.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyclingMount);
export default __webpack_public_path__ + "static/media/cyclingMount.cd699ec9d86b95e78b44996532499470.svg";
export { ForwardRef as ReactComponent };